import { IconLayout } from '@tabler/icons-react';
import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import { uploadImage } from '../../../../api/api.global';
import AddLinkToBlock from '../AddLinkToBlock';
import { ensureHttpPrefix } from '../../../../utils/url.utils';

const GridBlock = ({ blockData, createBlockFunction, cancelFunction }) => {

    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);
    const [isLink, setIsLink] = useState(false)

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            e.target.value = null;
        } else {
            setFile(file);
        }
    }

    const onCancel = () => {
        if (cancelFunction) {
            cancelFunction();
        }
    }

    const create = async () => {
        if (file) {
            let data = {
                blockType: 5,
                images: [{
                    link: document.getElementById('link')?.value?.trim(),
                    title: document.getElementById('title').value?.trim(),
                    description: document.getElementById('description').value?.trim(),
                    destinationUrl: ensureHttpPrefix(document.getElementById('destinationUrl')?.value?.trim()),
                    image: file ? await uploadImage(file, 'advy-pages') : '',
                    shortLinkDomain: 'advy.me',
                }],
            }
            createBlockFunction(data);
            onCancel();
        } else {
            toast.error("Image Required");
        }
    };

    return (
        <div className='p-3 rounded-lg border-2 border-primary'>
            <p className="flex items-center text-sm font-semibold gap-2"> <IconLayout size={18} /> Grid </p>
            <div className="mb-2">
                <input type="file" accept="image/*" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                <button onClick={() => imageUploadInputRef.current.click()}>
                    <img src={file ? URL.createObjectURL(file) : blockData?.image ? URL.createObjectURL(blockData?.image) : (process.env.PUBLIC_URL + "/images/image-upload.png")} id='link-image-preview' className='cursor-pointer max-w-[180px] max-h-[200px] rounded-lg object-cover' alt="" />
                </button>
                <p className="text-xs text-gray-400">*Maximum size: 5MB</p>
            </div>

            <div className='w-full'>
                <p className="text-md font-semibold mb-1.5">Title & Description</p>
                <input type="text" className="form-control mb-2 w-full" placeholder="Enter Title" id='title' maxLength={255} />
                <input type="text" className="form-control w-full" placeholder="Enter Description (Optional)" id='description' maxLength={140} />
            </div>

            <div className='flex gap-3 items-center mt-3'>
                <button className={`matchCornerButton ${isLink ? 'on' : 'off'}`} onClick={() => setIsLink(prev => !prev)}>
                    <span className="pin" />
                </button> <label htmlFor="range" className='text-md font-semibold'>Add a link</label>
            </div>

            {isLink && <div>
                <AddLinkToBlock />
            </div>}

            <div className="flex justify-end items-center mt-3 gap-3">
                <button className="font-semibold text-sm border-2 border-primary px-3 py-1.5 rounded-full" onClick={() => onCancel()}>Cancel</button>
                <button className="font-semibold text-sm text-white bg-primary px-3 py-2 rounded-full" onClick={() => create()}>Create</button>
            </div>

        </div>
    )
}

export default GridBlock